import React from 'react';
import Select from '../Select/Select';
import { CLIENT_DOCUMENT_TYPE } from '../../constants';

const SelectClientID = ({ ...props }) => {
  return <Select options={CLIENT_DOCUMENT_TYPE} label={'Тип документа'} placeholder={'Выберите из списка'} {...props} />;
};

export default SelectClientID;
